import { CmsComponentsBase } from '@/cmsComponents/base';
import { CmsComponentsEeg } from '@/cmsComponents/eeg';
import EegLandingPageHeader from '@uikit/components/EegLandingPageHeader/EegLandingPageHeader';

const EegLandingPageCmsComponents = {
  ...CmsComponentsBase,
  ...CmsComponentsEeg,
  'eeg-landing-page-header': EegLandingPageHeader,
};

export default EegLandingPageCmsComponents;
